import React, { useState, useRef, useContext } from "react";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineController,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ChartsContext from "contexts/ChartsContext";
import { Card, Row, Col, Form } from "react-bootstrap";


ChartJS.register(LineController, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

function TotalEnrollInsights() {
    const chartRef = useRef(null);
    const [isCumulative, setIsCumulative] = useState(true);

    const {
        updateTime,
        registrationPerDay
    } = useContext(ChartsContext);

    // Debug: Log registration data
    React.useEffect(() => {
        console.log("TotalEnrolInsights - Registration Data:", {
            registrationPerDay
        });
    }, [registrationPerDay]);

    const eventRegistrationData = registrationPerDay || {};

    const registrationDates = eventRegistrationData ? Object.keys(eventRegistrationData) : [];
    let registrationCounts = registrationDates.map(date => eventRegistrationData[date]);
    let trendLineData = [...registrationCounts];
    let chartLabel = isCumulative ? "Cumulative Registrations" : "Registrations Per Day";
    // Calculate cumulative data if the switch is on
    if (isCumulative) {
        let cumulativeSum = 0;
        registrationCounts = registrationCounts.map(value => {
            cumulativeSum += value;
            return cumulativeSum;
        });

        // Apply the same cumulative logic to trendLineData if needed
        let cumulativeTrendSum = 0;
        trendLineData = trendLineData.map(value => {
            cumulativeTrendSum += value; // Replace this with your actual trend calculation if different
            return cumulativeTrendSum;
        });
    }

    const data = {
        labels: registrationDates,
        datasets: [
            {
                data: registrationCounts,
                backgroundColor: '#11c5db', // Solid azure color for bars
                borderColor: '#11c5db',
                borderWidth: 1,
                order: 2,
                label: chartLabel,
            },
            {
                // Line chart dataset (overlay)
                data: trendLineData,
                borderColor: 'lightgreen',
                backgroundColor: 'transparent',
                borderWidth: 2,
                order: 1,
                label: 'Trend Line',
                type: 'line', // Specify 'line' type
            }
        ]
    };

    // Chart options
    const options = {
        scales: {
            y: {
                beginAtZero: true
            }
        },
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2.2,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true, // Use point style for legend symbols
                },
            },
            title: {
                display: false,
                text: 'Event Registration Per Day',
            },
        },
    };

    const eventLabel = '清明法會';

    return (
        <>
            <Card className="card-stats">
                <Card.Header>
                    <Row className="align-items-center mb-3">
                        <Col>
                            <Card.Title as="h4">Event Registrations</Card.Title>
                            <p className="card-category">Bar Chart</p>
                        </Col>
                        <Col xs="auto" className="d-flex justify-content-end">
                            <Form.Label htmlFor="cumulative-switch" className="mr-2 mt-1">{chartLabel}</Form.Label>
                            <Form.Check
                                type="switch"
                                id="cumulative-switch"
                                checked={isCumulative}
                                onChange={() => setIsCumulative(!isCumulative)}
                                className="align-self-center custom-switch-info"
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md="12" className="text-center">
                            <p className="mb-0"><span className="font-weight-bold text-warning">{eventLabel}</span> 報名趨勢</p>
                        </Col>
                    </Row>
                    <hr />
                </Card.Header>
                <Card.Body>
                    <Bar data={data} options={options} ref={chartRef} />
                </Card.Body>
                <Card.Footer>
                    <hr />
                    <div className="stats">
                        <i className="fas fa-redo mr-1"></i>
                        Updated at <span className="font-weight-bold">{updateTime}</span>
                    </div>
                </Card.Footer>
            </Card>
        </>
    )
}

export default TotalEnrollInsights;
